<template>
  <div class="bg-white flex flex-col h-full">
    <div class="flex justify-between items-start">
      <span class="flex-none font-semibold text-black-soft text-xl pt-1">
        How to fix
      </span>
    </div>
    <expandable-list :key="refreshExpandableList" :items="FIXES" class="mt-5"/>
  </div>
</template>

<script>
import ExpandableList from '@/components/common/ExpandableList'
import testReportModule from '@/store/modules/test-report.module'

const FIXES = [
  {
    title: 'Insufficient examples',
    text: 'If you have less than 15 examples, simply adding several more can fix this test.'
  },
  {
    title: 'Overlapping examples',
    text: 'There may be overlapping examples with other answers – removing overlapping examples could fix the issue.'
  }
]

export default {
  name: 'AnswersReportExampleDetailBottom',

  components: {
    ExpandableList
  },

  props: {
    botId: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      FIXES,
      refreshExpandableList: 0
    }
  },

  computed: {
    selectedExample: testReportModule.getSelectedExample
  },

  watch: {
    deep: true,
    selectedExample() {
      this.refreshExpandableList += 1
    }
  }
}
</script>

